/* eslint-disable react/no-unescaped-entities */
import React from "react";
import Nav from "./Nav";
import "./styles/Ideias.css";

function Ideias() {
  const skillsData =[
    {
      imgSrc: "https://img.freepik.com/free-vector/wishes-concept-illustration_114360-7248.jpg?w=740&t=st=1693932754~exp=1693933354~hmac=910687a7e967dae2a9b8e5fc365c74c998ff28cf42d3e9397dddd65c40184d48",
      title: "Passo 1 - Criar o Desejo",
      description: "Despertar o apetite na leitura de livros significa criar interesse e entusiasmo nos leitores, tornando o conteúdo do livro tão atraente que eles fiquem ansiosos para continuar lendo e descobrir mais sobre a história ou o assunto."
    },
    {
      imgSrc: "https://img.freepik.com/free-vector/concentration-focus-business-goal-target-business-goal-solution-concept_1150-52724.jpg?w=826&t=st=1693932923~exp=1693933523~hmac=8f0d2ce4a36f226c0cf3c623c6755760705154dc57312be7edb553f5aa3323e1",
      title: "Passo 2 - Focar e entrar em um fluxo",
      description: "Isso significa alcançar um estado mental em que alguém está totalmente imerso em uma tarefa ou atividade, concentrando-se profundamente e perdendo a noção do tempo. Esse estado é ideal para a leitura, pois permite uma absorção profunda e eficaz do conteúdo do livro."
    },
    {
      imgSrc:"https://img.freepik.com/free-vector/hand-drawn-flat-design-overwhelmed-people-illustration_23-2149335658.jpg?w=740&t=st=1693933091~exp=1693933691~hmac=56278da0840cf97b40ef2a20b2587d47a8a8edf215c4dc85720e4116460e3d64",
      title: "Passo 3 - Elimine Distrações",
      description:"Desligar o telefone, fechar os olhos e fazer uma respiração profunda refere-se a um momento de preparação antes de iniciar a leitura. Isso envolve desconectar-se de distrações, como o telefone, e relaxar com uma respiração profunda, criando um ambiente propício para a leitura focada.",
    },
    {
      imgSrc:"https://img.freepik.com/free-vector/hand-drawn-apple-fruit-illustration_53876-2980.jpg?w=740&t=st=1693933862~exp=1693934462~hmac=81a803341ef9c5d9b7de408ce6f837025b971a659aa47f0ccde978067ae39996",
      title: "Passo 4 - Abra o livro e aplique o método Pomodoro para leitura eficiente. ",
      description:"O método Pomodoro envolve ler o livro com foco total por um período de tempo definido, seguido por um breve intervalo. Isso ajuda na leitura eficiente e na manutenção da concentração ao longo do tempo."
    },
    {
      imgSrc: "https://img.freepik.com/free-vector/cartoon-illustration-knowledge-concept-cartoon-illustration-pencil-rocket-launch-book_1150-50871.jpg?w=740&t=st=1693934327~exp=1693934927~hmac=0a3bf78af1af6781b1d2a5c3d42ce3fdf8ea7fb9a75e988a5c1f773de482778c", 
      title: "Passo 5 - Percorra rapidamente todo o livro para preparar sua mente para receber as informações",
      description: "Antes de mergulhar profundamente na leitura, faça uma leitura rápida de todo o livro para preparar sua mente, obtendo uma visão geral do conteúdo antes de uma leitura mais detalhada."
    },
    {
      imgSrc: "https://img.freepik.com/free-vector/start_53876-25533.jpg?w=740&t=st=1693934271~exp=1693934871~hmac=f4296f97d62e67b3397c890c273674da767608f4573277635a513702c526d264",
      title: "Passo 6 - Tente começar a leitura pelas páginas que mais lhe interessam",
      description: "Inicie a leitura pelas páginas ou seções do livro que mais despertam seu interesse. Isso pode manter sua motivação e envolvimento enquanto você começa a leitura."
    },
    {
      imgSrc: "https://img.freepik.com/free-vector/hand-holding-pen-concept-illustration_114360-8460.jpg?w=740&t=st=1693934412~exp=1693935012~hmac=b9ace41e676faea5011022348ba71898bb7e36eb479a81519855bc995e9d4b24", 
      title: "Passo 7 - Use uma caneta para percorrer as páginas",
      description: "Utilize uma caneta ou marcador para destacar pontos-chave, fazer anotações nas margens ou marcar seções importantes. Isso ajuda a compreender e lembrar o conteúdo com mais facilidade."
    },
    {
      imgSrc: "https://img.freepik.com/free-vector/left-hander-concept-illustration_114360-2305.jpg?w=740&t=st=1693934448~exp=1693935048~hmac=ab3593195d9ecc6d2558a54c10accee0148962b1296c52bd148fc6a35402e081", 
      title: "Passo 8 - Tire notas durante a leitura",
      description: "Mantenha um caderno ou bloco de notas ao seu lado para fazer anotações enquanto lê. Isso ajuda a registrar pensamentos, ideias e informações importantes para referência futura."
    }
  ];

  return (
    <div>
      <Nav />
      <div className="Ideias">
        <div className="top-container">
          <h1>Ideias</h1>
          <h2>Como Construir o Hábito da Leitura</h2>
        </div>
        <div className="middle-container">
          <div className="skills">
            <h2>Como Ler um Livro em 7 Dias</h2>
            {skillsData.map((skill, index) => (
              <div className="skill-row" key={index}>
                <img className={index % 2 === 0 ? "image-skill": "image-skill1"} src={skill.imgSrc} alt={`Skill ${index + 1}`} />
                <h3>{skill.title}</h3>
                <p>{skill.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Ideias;
